import { render, staticRenderFns } from "./ProdVehicleGroupReport.vue?vue&type=template&id=55c8d108&scoped=true&"
import script from "./ProdVehicleGroupReport.vue?vue&type=script&lang=js&"
export * from "./ProdVehicleGroupReport.vue?vue&type=script&lang=js&"
import style0 from "./ProdVehicleGroupReport.vue?vue&type=style&index=0&id=55c8d108&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c8d108",
  null
  
)

export default component.exports